import React from 'react';

import { CellRenderer, MainColumns } from '../../../../../../components/TableGrid';
import { OwnerDetail } from '../../../../../../generated/model/models';
import DetailsDataTableWithHistory from '../../shared/DetailsDataTableWithHistory';

export interface Props {
  data?: OwnerDetail;
}

const columns: MainColumns[] = [
  { field: 'ownerType', minWidth: 200, flex: 1 },
  {
    field: 'ownerName',
    minWidth: 200,
    flex: 1,
    cellRenderer: CellRenderer.ValueOrUnknown,
    cellClass: 'multipleLineCell',
    autoHeight: true,
  },
  { field: 'ownershipType', minWidth: 200, flex: 1 },
  {
    field: 'sharesText',
    minWidth: 150,
    flex: 1,
  },
  {
    field: 'votingSharesText',
    minWidth: 180,
    flex: 1,
  },
  { field: 'officialValidFrom', minWidth: 150, flex: 1 },
  { field: 'officialValidTo', minWidth: 150, flex: 1 },
];

const OwnershipOwners: React.FC<Props> = ({ data }) => {
  return (
    <DetailsDataTableWithHistory
      title={'owners'}
      translationsScope={'companies:companyOwnership'}
      data={data}
      columns={columns}
      defaultHistoryToggleValue={true}
    />
  );
};

export default OwnershipOwners;
